import { createFileRoute } from "@tanstack/react-router";
import { AuthCard } from "@/components/auth/auth-card";
import { Link } from "@/components/ui/link";
import { env } from "../../../env";

export const Route = createFileRoute("/_unauthed/verify-email")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <AuthCard
      description={
        env.VITE_ENVIRONMENT !== "production"
          ? "You are in a non-production environment, so your email is already verified."
          : "Check your email for a verification link. You must verify your email address before signin in."
      }
      title="Verify your email address"
    >
      <div className="flex justify-end">
        <Link to="/login" variant="default">
          Back to login
        </Link>
      </div>
    </AuthCard>
  );
}
